.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--wix-forms-formRowSpacing, 24px);
}

.column {
  column-gap: var(--wix-forms-formColumnSpacing, 24px);
}

.row {
  row-gap: var(--wix-forms-formRowSpacing, 0);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvYnVpbGR1c2VyL3dvcmsvMTI1ODI5YTU5MGEwYjMxYS9wYWNrYWdlcy9mb3JtLWZpZWxkcy9kaXN0L2VzbS91aS9mb3JtL2NvbXBvbmVudHMvZ3JpZCIsInNvdXJjZXMiOlsiZ3JpZC5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLmNvbnRhaW5lciB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIHdpZHRoOiAxMDAlO1xuICBnYXA6IHZhcigtLXdpeC1mb3Jtcy1mb3JtUm93U3BhY2luZywgMjRweCk7XG59XG5cbi5jb2x1bW4ge1xuICBjb2x1bW4tZ2FwOiB2YXIoLS13aXgtZm9ybXMtZm9ybUNvbHVtblNwYWNpbmcsIDI0cHgpO1xufVxuXG4ucm93IHtcbiAgcm93LWdhcDogdmFyKC0td2l4LWZvcm1zLWZvcm1Sb3dTcGFjaW5nLCAwKVxufVxuIl19 */